import { AutomationChannel, AutomationTrigger } from 'apis/automations';
import { AppModalBase } from 'app/types/appModal.types';

/** Represents the confirm modal. */
export type AutomationModal = AppModalBase<
  'app:automation',
  AutomationArg,
  AutomationResult
>;

export type AutomationArg = {
  /** Automation ID - For edit mode pass an ID - for create pass null */
  readonly automationId: string | null;
  /** Predefined channels */
  readonly predefinedChannels?: readonly AutomationChannel[];
  /** Predefined trigger */
  readonly predefinedTrigger?: AutomationTrigger;
};

export enum AutomationModalResultType {
  CANCEL = 'cancel',
  UPDATED = 'updated',
  CREATED = 'created',
  ERROR = 'error',
}
export type AutomationResult = {
  /** End result of modal action */
  readonly result: AutomationModalResultType;
  /** Automation ID of the updated/created automation, null if error or cancelled */
  readonly automationId: string | null;
};

export type AutomationModalFormValues = {
  name: string;
  description: string;
  channels: AutomationChannel[];
  trigger: null | AutomationTrigger;
};
